import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
export class EnergySystemData {
  get descriptor() {
    return EnergySystemData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDefaultEnergyCap = false;
    this._defaultEnergyCap = null;
    this._hasRegenerationInterval = false;
    this._regenerationInterval = null;
    this._hasPurchaseCost = false;
    this._purchaseCost = null;
    this._hasPurchaseAmount = false;
    this._purchaseAmount = null;
    this._hasDynamicRefill = false;
    this._dynamicRefill = null;
  }
  isEmpty() {
    if (this._hasDefaultEnergyCap) return false;
    if (this._hasRegenerationInterval) return false;
    if (this._hasPurchaseCost && !this._purchaseCost.isEmpty()) return false;
    if (this._hasPurchaseAmount) return false;
    if (this._hasDynamicRefill) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof EnergySystemData) {
      return value;
    }
    return EnergySystemData.fromJson(value);
  }
  static fromJson(json) {
    const result = new EnergySystemData();
    if (json.defaultEnergyCap != null) {
      result._hasDefaultEnergyCap = true;
      result._defaultEnergyCap = JsonToInt32.fromJson(json.defaultEnergyCap);
    }
    if (json.regenerationInterval != null) {
      result._hasRegenerationInterval = true;
      result._regenerationInterval = JsonToInt32.fromJson(json.regenerationInterval);
    }
    if (json.purchaseCost != null) {
      result._hasPurchaseCost = true;
      result._purchaseCost = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromJson(json.purchaseCost);
    }
    if (json.purchaseAmount != null) {
      result._hasPurchaseAmount = true;
      result._purchaseAmount = JsonToInt32.fromJson(json.purchaseAmount);
    }
    if (json.dynamicRefill != null) {
      result._hasDynamicRefill = true;
      result._dynamicRefill = JsonToBoolean.fromJson(json.dynamicRefill);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDefaultEnergyCap) {
      result.defaultEnergyCap = JsonToInt32.toJson(this._defaultEnergyCap);
    }
    if (this._hasRegenerationInterval) {
      result.regenerationInterval = JsonToInt32.toJson(this._regenerationInterval);
    }
    if (this._hasPurchaseCost && !this._purchaseCost.isEmpty()) {
      result.purchaseCost = dcei_wildsky_common_proto.InventoryItemKeyValuePair.toJson(this._purchaseCost);
    }
    if (this._hasPurchaseAmount) {
      result.purchaseAmount = JsonToInt32.toJson(this._purchaseAmount);
    }
    if (this._hasDynamicRefill) {
      result.dynamicRefill = JsonToBoolean.toJson(this._dynamicRefill);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get defaultEnergyCap() {
    return this._hasDefaultEnergyCap ? this._defaultEnergyCap : JsonToInt32.default;
  }
  get hasDefaultEnergyCap() {
    return this._hasDefaultEnergyCap;
  }
  setDefaultEnergyCap(path, value) {
    return {type: 'SET', path: path.concat(['defaultEnergyCap']), value};
  }
  deleteDefaultEnergyCap(path) {
    return {type: 'DELETE', path: path.concat(['defaultEnergyCap'])};
  }
  /**
   * @returns {number}
   */
  get regenerationInterval() {
    return this._hasRegenerationInterval ? this._regenerationInterval : JsonToInt32.default;
  }
  get hasRegenerationInterval() {
    return this._hasRegenerationInterval;
  }
  setRegenerationInterval(path, value) {
    return {type: 'SET', path: path.concat(['regenerationInterval']), value};
  }
  deleteRegenerationInterval(path) {
    return {type: 'DELETE', path: path.concat(['regenerationInterval'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair}
   */
  get purchaseCost() {
    return this._hasPurchaseCost ? this._purchaseCost : dcei_wildsky_common_proto.InventoryItemKeyValuePair.default;
  }
  get hasPurchaseCost() {
    return this._hasPurchaseCost;
  }
  setPurchaseCost(path, value) {
    return {type: 'SET', path: path.concat(['purchaseCost']), value: value.toJson()};
  }
  deletePurchaseCost(path) {
    return {type: 'DELETE', path: path.concat(['purchaseCost'])};
  }
  /**
   * @returns {number}
   */
  get purchaseAmount() {
    return this._hasPurchaseAmount ? this._purchaseAmount : JsonToInt32.default;
  }
  get hasPurchaseAmount() {
    return this._hasPurchaseAmount;
  }
  setPurchaseAmount(path, value) {
    return {type: 'SET', path: path.concat(['purchaseAmount']), value};
  }
  deletePurchaseAmount(path) {
    return {type: 'DELETE', path: path.concat(['purchaseAmount'])};
  }
  /**
   * @returns {boolean}
   */
  get dynamicRefill() {
    return this._hasDynamicRefill ? this._dynamicRefill : JsonToBoolean.default;
  }
  get hasDynamicRefill() {
    return this._hasDynamicRefill;
  }
  setDynamicRefill(path, value) {
    return {type: 'SET', path: path.concat(['dynamicRefill']), value};
  }
  deleteDynamicRefill(path) {
    return {type: 'DELETE', path: path.concat(['dynamicRefill'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "defaultEnergyCap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EnergySystemData(this);
              copy._hasDefaultEnergyCap = true;
              copy._defaultEnergyCap = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDefaultEnergyCap) {
                return this;
              }
              const copy = new EnergySystemData(this);
              copy._hasDefaultEnergyCap = false;
              copy._defaultEnergyCap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "regenerationInterval": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EnergySystemData(this);
              copy._hasRegenerationInterval = true;
              copy._regenerationInterval = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRegenerationInterval) {
                return this;
              }
              const copy = new EnergySystemData(this);
              copy._hasRegenerationInterval = false;
              copy._regenerationInterval = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "purchaseCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EnergySystemData(this);
              copy._hasPurchaseCost = true;
              copy._purchaseCost = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchaseCost) {
                return this;
              }
              const copy = new EnergySystemData(this);
              copy._hasPurchaseCost = false;
              copy._purchaseCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPurchaseCost) {
            const copy = new EnergySystemData(this);
            copy._hasPurchaseCost = true;
            copy._purchaseCost = dcei_wildsky_common_proto.InventoryItemKeyValuePair.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._purchaseCost.apply(type, path.slice(1), value);
          if (newValue === this._purchaseCost) {
            return this;
          }
          const copy = new EnergySystemData(this);
          copy._purchaseCost = copy._purchaseCost.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "purchaseAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EnergySystemData(this);
              copy._hasPurchaseAmount = true;
              copy._purchaseAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchaseAmount) {
                return this;
              }
              const copy = new EnergySystemData(this);
              copy._hasPurchaseAmount = false;
              copy._purchaseAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dynamicRefill": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new EnergySystemData(this);
              copy._hasDynamicRefill = true;
              copy._dynamicRefill = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDynamicRefill) {
                return this;
              }
              const copy = new EnergySystemData(this);
              copy._hasDynamicRefill = false;
              copy._dynamicRefill = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {EnergySystemData} other
   * @returns {EnergySystemData}
   */
  merge(other) {
    const copy = new EnergySystemData(this);
    if (other._hasDefaultEnergyCap) {
      copy._hasDefaultEnergyCap = true;
      copy._defaultEnergyCap = other._defaultEnergyCap;
    }
    if (other._hasRegenerationInterval) {
      copy._hasRegenerationInterval = true;
      copy._regenerationInterval = other._regenerationInterval;
    }
    if (other._hasPurchaseCost) {
      if (copy._hasPurchaseCost) {
        copy._purchaseCost = copy.purchaseCost.merge(other.purchaseCost);
      } else {
        copy._purchaseCost = other._purchaseCost;
      }
      copy._hasPurchaseCost = true;
    }
    if (other._hasPurchaseAmount) {
      copy._hasPurchaseAmount = true;
      copy._purchaseAmount = other._purchaseAmount;
    }
    if (other._hasDynamicRefill) {
      copy._hasDynamicRefill = true;
      copy._dynamicRefill = other._dynamicRefill;
    }
    return copy;
  }
}
EnergySystemData.default = new EnergySystemData();
class EnergySystemData_Builder {
  constructor(value) {
    this._value = new EnergySystemData(value);
  }
  build() {
    return new EnergySystemData(this._value);
  }
  setDefaultEnergyCap(value) {
    this._value._hasDefaultEnergyCap = true;
    this._value._defaultEnergyCap = value;
    return this;
  }
  deleteDefaultEnergyCap() {
    this._value._hasDefaultEnergyCap = false;
    this._value._defaultEnergyCap = null;
    return this;
  }
  setRegenerationInterval(value) {
    this._value._hasRegenerationInterval = true;
    this._value._regenerationInterval = value;
    return this;
  }
  deleteRegenerationInterval() {
    this._value._hasRegenerationInterval = false;
    this._value._regenerationInterval = null;
    return this;
  }
  setPurchaseCost(value) {
    this._value._hasPurchaseCost = true;
    this._value._purchaseCost = value;
    return this;
  }
  deletePurchaseCost() {
    this._value._hasPurchaseCost = false;
    this._value._purchaseCost = null;
    return this;
  }
  setPurchaseAmount(value) {
    this._value._hasPurchaseAmount = true;
    this._value._purchaseAmount = value;
    return this;
  }
  deletePurchaseAmount() {
    this._value._hasPurchaseAmount = false;
    this._value._purchaseAmount = null;
    return this;
  }
  setDynamicRefill(value) {
    this._value._hasDynamicRefill = true;
    this._value._dynamicRefill = value;
    return this;
  }
  deleteDynamicRefill() {
    this._value._hasDynamicRefill = false;
    this._value._dynamicRefill = null;
    return this;
  }
}
EnergySystemData.Builder = EnergySystemData_Builder;
class EnergySystemData_WithParent {
  /**
   * @param {EnergySystemData} value
   * @param {EnergySystemData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return EnergySystemData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDefaultEnergyCap() {
    if (this._cachedHasDefaultEnergyCap === undefined) {
      if (this._value.hasDefaultEnergyCap) {
        this._cachedHasDefaultEnergyCap = true;
      } else {
        this._cachedHasDefaultEnergyCap = this._parent ? this._parent.hasDefaultEnergyCap : false;
      }
    }
    return this._cachedHasDefaultEnergyCap;
  }
  get defaultEnergyCap() {
    if (this._cachedDefaultEnergyCap === undefined) {
      if (this._value.hasDefaultEnergyCap) {
        this._cachedDefaultEnergyCap = this._value.defaultEnergyCap;
      } else {
        this._cachedDefaultEnergyCap = this._parent ? this._parent.defaultEnergyCap : this._value.defaultEnergyCap;
      }
    }
    return this._cachedDefaultEnergyCap;
  }
  get hasRegenerationInterval() {
    if (this._cachedHasRegenerationInterval === undefined) {
      if (this._value.hasRegenerationInterval) {
        this._cachedHasRegenerationInterval = true;
      } else {
        this._cachedHasRegenerationInterval = this._parent ? this._parent.hasRegenerationInterval : false;
      }
    }
    return this._cachedHasRegenerationInterval;
  }
  get regenerationInterval() {
    if (this._cachedRegenerationInterval === undefined) {
      if (this._value.hasRegenerationInterval) {
        this._cachedRegenerationInterval = this._value.regenerationInterval;
      } else {
        this._cachedRegenerationInterval = this._parent ? this._parent.regenerationInterval : this._value.regenerationInterval;
      }
    }
    return this._cachedRegenerationInterval;
  }
  get hasPurchaseCost() {
    if (this._cachedHasPurchaseCost === undefined) {
      if (this._value.hasPurchaseCost) {
        this._cachedHasPurchaseCost = true;
      } else {
        this._cachedHasPurchaseCost = this._parent ? this._parent.hasPurchaseCost : false;
      }
    }
    return this._cachedHasPurchaseCost;
  }
  get purchaseCost() {
    if (!this._cachedPurchaseCost) {
      if (this._value.hasPurchaseCost) {
        this._cachedPurchaseCost = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(this._value.purchaseCost, this._parent && this._parent.hasPurchaseCost ? this._parent.purchaseCost : null);
      } else {
        this._cachedPurchaseCost = this._parent ? new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(dcei_wildsky_common_proto.InventoryItemKeyValuePair.default, this._parent.purchaseCost) : dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent.default;
      }
    }
    return this._cachedPurchaseCost;
  }
  get hasPurchaseAmount() {
    if (this._cachedHasPurchaseAmount === undefined) {
      if (this._value.hasPurchaseAmount) {
        this._cachedHasPurchaseAmount = true;
      } else {
        this._cachedHasPurchaseAmount = this._parent ? this._parent.hasPurchaseAmount : false;
      }
    }
    return this._cachedHasPurchaseAmount;
  }
  get purchaseAmount() {
    if (this._cachedPurchaseAmount === undefined) {
      if (this._value.hasPurchaseAmount) {
        this._cachedPurchaseAmount = this._value.purchaseAmount;
      } else {
        this._cachedPurchaseAmount = this._parent ? this._parent.purchaseAmount : this._value.purchaseAmount;
      }
    }
    return this._cachedPurchaseAmount;
  }
  get hasDynamicRefill() {
    if (this._cachedHasDynamicRefill === undefined) {
      if (this._value.hasDynamicRefill) {
        this._cachedHasDynamicRefill = true;
      } else {
        this._cachedHasDynamicRefill = this._parent ? this._parent.hasDynamicRefill : false;
      }
    }
    return this._cachedHasDynamicRefill;
  }
  get dynamicRefill() {
    if (this._cachedDynamicRefill === undefined) {
      if (this._value.hasDynamicRefill) {
        this._cachedDynamicRefill = this._value.dynamicRefill;
      } else {
        this._cachedDynamicRefill = this._parent ? this._parent.dynamicRefill : this._value.dynamicRefill;
      }
    }
    return this._cachedDynamicRefill;
  }
  update(current, parent) {
    const result = new EnergySystemData_WithParent(current, parent);
    if (this._cachedPurchaseCost && this._value.hasPurchaseCost && current.hasPurchaseCost) {
      if (this._value.purchaseCost === current.purchaseCost && this._parent === parent) {
        result._cachedPurchaseCost = this._cachedPurchaseCost;
      } else {
        result._cachedPurchaseCost = this._cachedPurchaseCost.update(current.purchaseCost, parent && parent.hasPurchaseCost ? parent.purchaseCost : null);
      }
    }
    return result;
  }
}
EnergySystemData_WithParent.default = new EnergySystemData_WithParent(EnergySystemData.default, null);
EnergySystemData.WithParent = EnergySystemData_WithParent;
class EnergySystemData_Descriptor {
  get defaultEnergyCap() {
    if (!this._defaultEnergyCap) {
      this._defaultEnergyCap = {
        name: "defaultEnergyCap",
        Name: "DefaultEnergyCap",
        number: 1,
        protoType: 5,
        protoName: "default_energy_cap",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._defaultEnergyCap;
  }
  get regenerationInterval() {
    if (!this._regenerationInterval) {
      this._regenerationInterval = {
        name: "regenerationInterval",
        Name: "RegenerationInterval",
        number: 2,
        protoType: 5,
        protoName: "regeneration_interval",
        type: JsonToInt32,
        options: {
          comments: "X seconds per 1 energy",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._regenerationInterval;
  }
  get purchaseCost() {
    if (!this._purchaseCost) {
      this._purchaseCost = {
        name: "purchaseCost",
        Name: "PurchaseCost",
        number: 3,
        protoType: 11,
        protoName: "purchase_cost",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        options: {
          comments: "If dynamic refill, this is the unit cost per energy, otherwise this is the total cost for the amount defined below",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseCost;
  }
  get purchaseAmount() {
    if (!this._purchaseAmount) {
      this._purchaseAmount = {
        name: "purchaseAmount",
        Name: "PurchaseAmount",
        number: 4,
        protoType: 5,
        protoName: "purchase_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseAmount;
  }
  get dynamicRefill() {
    if (!this._dynamicRefill) {
      this._dynamicRefill = {
        name: "dynamicRefill",
        Name: "DynamicRefill",
        number: 5,
        protoType: 8,
        protoName: "dynamic_refill",
        type: JsonToBoolean,
        options: {
          comments: "If this is set, PurchaseCost will become unit price This field itself means to set users\'s energy to the max defined in data with dynamic cost",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dynamicRefill;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.defaultEnergyCap,
        this.regenerationInterval,
        this.purchaseCost,
        this.purchaseAmount,
        this.dynamicRefill,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDefaultEnergyCap",
        Name: "DummyOneofForDefaultEnergyCap",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRegenerationInterval",
        Name: "DummyOneofForRegenerationInterval",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchaseCost",
        Name: "DummyOneofForPurchaseCost",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchaseAmount",
        Name: "DummyOneofForPurchaseAmount",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDynamicRefill",
        Name: "DummyOneofForDynamicRefill",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
EnergySystemData.descriptor = new EnergySystemData_Descriptor();
